import gql from 'graphql-tag';

export const getClientQL = gql`
query($id: ID!) {
  client(id: $id) {
    id
    name
    country
    picName
    picEmail
    cse {
      id
    }
  }
}
`;

export const listClientQL = gql`
query {
  clients: listClient(offset: 0, limit: 1000) {
    id
    name
    country
  }
}
`;
